import React, { useContext } from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./userAccess.scss";
import Sidebar from "../Sidebar/Sidebar";
import AddUser from "./AddUser/AddUser";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader/Loader";

function UserAccess() {
  const navigate = useNavigate();

  const [members, setMembers] = useState([]);
  const [addedUser, setAddedUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [scope, setScope] = useState("");

  const fetchEmployeesDetail = async () => {
    setLoading(true);
    const url =
      "https://ballersapi.ballerslife.co/api/v1/admin/get_all_employee_details";
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      if (response.status === 404) {
        toast.error(data.detail);
        setLoading(false);
        setNoData(true);
      } else if (response.status === 403) {
        toast.error(data.detail);
        setLoading(false);
        setScope(data.detail);
      } else if (response.status === 200) {
        setMembers(data);
        setLoading(false);
        setNoData(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // delete user
  const handleDelete = async (member) => {
    try {
      const url = `https://ballersapi.ballerslife.co/api/v1/admin/delete_employee?emp_id=${member.emp_user_id}`;
      const accessToken = document.cookie
        .split("; ")
        .find((cookie) => cookie.startsWith("access_token="))
        .split("=")[1];

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();

      if (response.status === 403) {
        toast.error(data.detail);
      } else if (response.status === 200) {
        toast.success(data);
        fetchEmployeesDetail();
      } else {
        toast.error(data.detail);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while deleting employee");
    }
  };

  const [hideSvg, setHideSvg] = useState(false);
  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };
  const [hideDetails, setHideDetails] = useState(false);
  const [hidenDetailsIndex, setHidenDetailsIndex] = useState(null);

  const handleDetails = (index) => {
    setHideDetails(!hideDetails);
    setHidenDetailsIndex(index);
  };

  const [updateStatus, setUpdateStatus] = useState(false);
  const handleUpdateStatus = () => {
    setUpdateStatus(!updateStatus);
  };

  useEffect(() => {
    fetchEmployeesDetail();
    document.title = ` User Access | Ballers`;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      {loading ? (
        <Loader />
      ) : (
        <div className="content">
          <div className="user" id="scrollable-container">
            <div className="svgMain" onClick={handleSvg}>
              {hideSvg ? (
                <div className="closeSvg"></div>
              ) : (
                <div className="hamburgerSvg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#0F0223"
                    stroke="#eee2e2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-menu"
                  >
                    <line x1="4" x2="20" y1="12" y2="12" />
                    <line x1="4" x2="20" y1="6" y2="6" />
                    <line x1="4" x2="20" y1="18" y2="18" />
                  </svg>
                </div>
              )}
            </div>

            <div className="userSec">
              {hideSvg ? (
                <div onClick={handleSvg}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#0F0223"
                    stroke="#eee2e2"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-x-square"
                  >
                    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                    <path d="m15 9-6 6" />
                    <path d="m9 9 6 6" />
                  </svg>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {scope === "Insufficient scope, please contact your admin" ? (
            <>
              <div className="portMainicon">
                <div className="portfolioImg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#FFB000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-shield-off"
                    style={{ marginBottom: "1rem" }}
                  >
                    <path d="m2 2 20 20" />
                    <path d="M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71" />
                    <path d="M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264" />
                  </svg>
                </div>
                <p className="portNotfound">
                  Access Denied: You do not have sufficient permissions to view
                  this page.
                </p>
              </div>
            </>
          ) : (
            <>
              <div>
                <div className="btnMain">
                  <p className="addBtn" onClick={handleUpdateStatus}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ffcc14"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-plus"
                    >
                      <path d="M5 12h14" />
                      <path d="M12 5v14" />
                    </svg>
                  </p>
                </div>
                <div className="headerMain">
                  <div className="accessHeader">
                    <div className="accessHeaderSec">Emp_Id</div>
                    <div className="accessHeaderSec">Email_Id</div>
                    <div className="accessHeaderSec">Emp_Role</div>
                  </div>
                  <div className="cardFlex">
                    <div className="userAccMain">
                      {members.map((member, index) => (
                        <div>
                          <div
                            key={index}
                            className="userCredSec"
                            style={{
                              marginBottom:
                                hideDetails && hidenDetailsIndex === index
                                  ? "0"
                                  : "1rem",
                            }}
                          >
                            <div className="memberSecContName">
                              {member.emp_user_id}
                            </div>
                            <div className="memberSecCont">
                              {member.email_id}
                            </div>
                            <div className="memberSecCont">
                              {member.emp_role.join("  ")}
                            </div>
                            <div className="delBtn">
                              <p
                                onClick={() => {
                                  handleDelete(member);
                                }}
                                className="deleteBtnSec"
                              >
                                Delete Access
                              </p>
                            </div>
                          </div>

                          <div className="accesscardComp">
                            <div className="userAccessDetailCard">
                              <div className="membersDetail">
                                <p className="lable">Emp_Id :</p>
                                {member.emp_user_id}
                              </div>
                              <div className="membersDetail">
                                <p className="lable">Email_Id :</p>
                                {member.email_id}
                              </div>
                              <div className="membersDetail">
                                <p className="lable">Emp_Role :</p>
                                {member.emp_role}
                              </div>
                              <div className="delBtn">
                                <p
                                  onClick={() => {
                                    handleDelete(member);
                                  }}
                                  className="deleteBtnSec"
                                >
                                  Delete Access
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {updateStatus ? (
                  <div className="userAccessStatusMain">
                    <AddUser
                      handleUpdateStatus={handleUpdateStatus}
                      fetchEmployeesDetail={fetchEmployeesDetail}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default UserAccess;
